export const GRAPH_HEIGHT = 150;
export const LABEL_OFFSET = 118;
export const LABEL_X_POSITION = (containerWidth: number) =>
  containerWidth - LABEL_OFFSET;

/** Victory chart padding. `left` is the Y-axis / tooltip flyout gutter. */
export const GRAPH_CHART_PADDING = {
  top: 34,
  right: 130,
  bottom: 32,
  left: 45,
} as const;

export const CONDENSED_INNER_PADDING = 1.5;
/** Shared card/chart cap so sparse graphs and single-result rows stay aligned. */
export const CONDENSED_CONTENT_MAX_WIDTH = 800;
export const CONTAINED_ROW_PADDING_LEFT = 6.5;
export const CONTAINED_ROW_GRAPH_PADDING_LEFT = 0;
export const CONTAINED_ROW_PADDING_RIGHT = 8;
